/*
When creating MVTs that are used on the front-end, we've been asked to limit the description provided. This makes
it harder for our competitors to find out what we are experimenting with.

If you add to this file, please use the following variable format and sort the list:

Format: MVT_<MVT_NUMBER>
*/

export const MVT_1066 = 'mvt_1066_placeholders_web';
export const MVT_1068 = 'mvt_1068_mgm_mobile_banner';
export const MVT_1103 = 'mvt_1103_cp_hide_delivery_fee_web';
export const MVT_1115 = 'mvt_1115_web';
export const MVT_1139 = 'mvt_1139_co_home_graphql';
export const MVT_1146 = 'mvt_1146_co_search_web';
export const MVT_1164 = 'mvt_1164_co_homepage_redirect';

/**
 * Whether the user is in the Punch Card experiment
 */
export const MVT_POE_12 = 'mvt_poe_12_punch_card';
